/**
 * Evita promesas colgadas (p. ej. red o Supabase sin respuesta).
 * @template T
 * @param {Promise<T>} promise
 * @param {number} ms
 * @param {string} [timeoutMessage]
 * @returns {Promise<T>}
 */
export function promiseWithTimeout(promise, ms, timeoutMessage = 'Tiempo de espera agotado.') {
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => reject(new Error(timeoutMessage)), ms);
    Promise.resolve(promise)
      .then(v => {
        clearTimeout(t);
        resolve(v);
      })
      .catch(e => {
        clearTimeout(t);
        reject(e);
      });
  });
}
